"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoryPointImpl = void 0;
const Contract = require("@tableau/api-external-contract-js");
const TableauError_1 = require("../TableauError");
const SheetUtils_1 = require("../Utils/SheetUtils");
const DashboardImpl_1 = require("./DashboardImpl");
const SheetInfoImpl_1 = require("./SheetInfoImpl");
const WorksheetImpl_1 = require("./WorksheetImpl");
class StoryPointImpl {
    constructor(_storyPointInfoImpl, sheetInfos, registryId, containedSheetInfo) {
        this._storyPointInfoImpl = _storyPointInfoImpl;
        if (containedSheetInfo) {
            this._containedSheetImpl = this.createContainedSheet(containedSheetInfo, sheetInfos, registryId);
        }
    }
    get index() {
        return this._storyPointInfoImpl.index;
    }
    get caption() {
        return this._storyPointInfoImpl.caption;
    }
    get active() {
        return this._storyPointInfoImpl.active;
    }
    get updated() {
        return this._storyPointInfoImpl.updated;
    }
    set updated(updated) {
        this._storyPointInfoImpl.updated = updated;
    }
    get parentStory() {
        return this._storyPointInfoImpl.parentStory;
    }
    get containedSheet() {
        return this._containedSheetImpl;
    }
    get storyPointId() {
        return this._storyPointInfoImpl.storyPointId;
    }
    createContainedSheet(containedSheetInfo, sheetInfos, registryId) {
        const containedSheetIdx = -1;
        const publishedSheetInfo = SheetUtils_1.SheetUtils.getPublishedSheetInfoByName(containedSheetInfo.name, sheetInfos);
        const containedSheetSize = SheetUtils_1.SheetUtils.createAutomaticSize();
        const isContainedSheetHidden = publishedSheetInfo === undefined;
        const containedSheetUrl = publishedSheetInfo ? publishedSheetInfo.url : '';
        // Contained sheets aren't active - the containing sheet is active.
        const containedSheetActive = false;
        const containedSheetInfoImpl = new SheetInfoImpl_1.SheetInfoImpl(containedSheetInfo.name, SheetUtils_1.SheetUtils.getSheetTypeEnum(containedSheetInfo.sheetType), containedSheetSize, containedSheetIdx, containedSheetActive, isContainedSheetHidden, containedSheetUrl);
        let sheetImpl;
        switch (containedSheetInfoImpl.sheetType) {
            case Contract.SheetType.Worksheet: {
                const vizId = {
                    worksheet: containedSheetInfoImpl.name,
                };
                sheetImpl = new WorksheetImpl_1.WorksheetImpl(containedSheetInfoImpl, registryId, vizId, null, this);
                break;
            }
            case Contract.SheetType.Dashboard: {
                const sheetPath = {
                    sheetName: containedSheetInfoImpl.name,
                    isDashboard: true,
                };
                sheetImpl = new DashboardImpl_1.DashboardImpl(containedSheetInfoImpl, containedSheetInfo.dashboardZones, sheetPath, registryId, this);
                break;
            }
            default: {
                throw new TableauError_1.TableauError(Contract.SharedErrorCodes.ServerError, 'Invalid SheetType');
            }
        }
        return sheetImpl;
    }
}
exports.StoryPointImpl = StoryPointImpl;
//# sourceMappingURL=StoryPointImpl.js.map